import {ideafactory} from "../globals";
import ClientConfig = ideafactory.config.ClientConfig;

export const config: ClientConfig = window.clientConfig;